import React, { type ReactNode } from 'react';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	cardFooter: {
		paddingTop: token('space.200'),
		paddingRight: token('space.200'),
		paddingBottom: token('space.200'),
		paddingLeft: token('space.200'),
		borderTopWidth: token('border.width'),
		borderTopStyle: 'solid',
		borderTopColor: token('color.border'),
	},
});

type CardFooterProps = {
	children: ReactNode;
};

export const CardFooter = ({ children }: CardFooterProps): React.JSX.Element => {
	return <Box xcss={styles.cardFooter}>{children}</Box>;
};
